<template>
  <div :class="swiperCustomClass" class="w-100">
    <Swiper class="swiper" ref="mySwiper" :options="sOptions">
      <SwiperSlide v-for="(data, index) in gamesData" :key="index">
        <GamePhotoCard
          v-for="(game, index2) in data"
          :key="index2"
          :game="game"
          class="card-gap"
        />
      </SwiperSlide>
      <div slot="pagination" class="swiper-pagination"></div>
      <!-- <div slot="button-prev" class="swiper-button-prev"></div>
    <div slot="button-next" class="swiper-button-next"></div> -->
    </Swiper>
  </div>
</template>

<script>
import GamePhotoCard from "@/components/GamePhotoCard.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

// import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
// import { Swiper as SwiperClass } from 'swiper/swiper.esm'
// const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass)

export default {
  components: {
    Swiper,
    SwiperSlide,
    GamePhotoCard,
  },
  props: {
    gameDataProps: {
      type: Array,
      default() {
        return [];
      },
    },
    swiperOption: {
      type: Object,
      default() {
        return {};
      },
    },
    swiperCustomClass: {
      type: String,
      default() {
        return "";
      },
    },
    swiperStartSlide: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      gamesData: [],
      sOptions: this.swiperOption,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  mounted() {
    // mounted里也写一边为了适应首页的死数据
    const games = this.gameDataProps;
    
    const arrEven = [];
    let group = [];
    games.forEach((g, i) => {
      group.push(g);
      if (i % 2) {
        arrEven.push(group);
        group = [];
      }
    });
    console.warn('gamesData', arrEven);
    this.gamesData = arrEven;
    if (this.swiperStartSlide) {
      this.swiper.slideTo(this.swiperStartSlide, 1000, false);
    }
  },
  watch: {
    gameDataProps(newVal) {
      if (newVal) {
        const games = [];
        newVal.filter((item) => {
          if (item.image) {
            games.push(item);
          }
        });
        console.log(newVal, "val");
        console.log(games, "games");
        const arrEven = [];
        let group = [];
        games.forEach((g, i) => {
          group.push(g);
          if (i % 2) {
            arrEven.push(group);
            group = [];
          }
        });
        this.gamesData = arrEven;
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";

.card-gap {
  &:first-child {
    margin-bottom: 41px;
  }
  &:last-child {
    position: relative;
    left: -135px;
  }
}
@media only screen and (max-width: 992px) {
  .card-gap {
    &:first-child {
      margin-bottom: 30px;
    }
  }
}
@media only screen and (max-width: 767px) {
  .card-gap {
    &:first-child {
      margin-bottom: 20px;
    }
  }
}
</style>
